import React, { useContext, useEffect, useMemo, useRef, useState , Fragment} from "react";
import { withRouter } from "react-router-dom";
import { Row, Col, Card, Button, Checkbox, Form, Icon, Spin, Modal, Skeleton, Tooltip } from "antd";
import ItemsMeasure from "./ItemsMeasure"
import ItemsMeasureUnits from "../../components/order_item_units/ItemsMeasureUnits"
import { OrderConfigContext } from "../../context/OrderConfigContext";
import { catalog as fetchSlCatalog, forAccount as fetchForAccount, losOptions as fetchSlLosOptions } from "../../api/ServiceLevels";
import { fetchRateSheet } from "../../api/Billing";
import { buildOrderTypeConfigIndex, buildServiceLevelIndex, DB_ORDER_TYPE_LEGACY_FALLBACK, buildLegLos, withAllStandardLos, resolveOrderServiceLevelLegLos, isLinehaulTariffLockedByServiceLevel, parseBillingConfigurations } from "../../helpers/serviceLevelDerivation";
import { fetchAccountBillingConfigs } from "../../api/Account";
import { checkServiceExistance } from "../../helpers/common";
import ServiceLevelHeader from "../../components/orders/ServiceLevelHeader";
import CreateOrderButton from "../../components/orders/CreateOrderButton";
import OrderLabelInfo from "./OrderLabelInfo";
import { fetchLocations } from "../../api/LocationsApi";
import AppConfig from "../../config/AppConfig";
import { WarehouseContext } from "../../context/WarehouseContext";
import { renderAlertMessage } from "../../helpers/common";
import { getAccountComponents, getAccountConfigs, getComponentDefs, getLevelOfServices, getLinehaulLevelOfServices } from "../../helpers/api_calls";
import { getValueFromArrayOfObjects } from "../../helpers/array_functions";
import { VehicleTypeApi } from "../../api/VehicleType";
import { UserContext } from "../../context/UserContext";
import { deleteOrder, fetchOrderDetails, fetchOrderDetails_v2, fetchOrderReferences, saveOrderCall, deleteDeliveryLocation } from "../../api/OrdersApi";
import CreateOrderSidebar from "./CreateOrderSidebar";
import moment from "moment";
import { fetchUsers } from "../../api/UsersApi";
import { OrgContext } from "../../context/OrgContext";
import SubOrders from "./SubOrders";
import ErrorComponent from "../../components/common/ErrorComponent";
import I18n from "../../common/I18n";
import { getLabelDescriptionForLocation, renderNotification } from "../../components/orders/OrderTypeIcons";
import { areAppointmentsInOrder, formatOrderApiResponse, isMultiDayOrder, validateLtlOnHandTimes } from "../../helpers/order_managemnt";
import ManageDetails from "../../components/orders/ManageDetails";
import OrderViewSidebar from "./OrderViewSidebar";
import Documents from "./Documents";
import AssignedDriverView from "./PickupDriverView";
import AddressLocationsView from "./AddressLocationsView";
import WarehouseAccessorials from "./WarehouseAccessorials";
import DispalyOrderAccessorial from "./DisplayOrderAccessorial";
import { Hidden } from "@mui/material";
import MultiStopLocationsView from "../../components/orders/MultiStopLocationsView";
import ConsigneeDetails from "./ConsigneeDetails";
import ShipperEmails from "./ShipperEmails";
import SectionCard from "./SectionCard";
import { isEmpty, sortServicesByNames } from "../../common/Common";
import { isLtlOrganization } from "../../helpers/orders";
import DriverIcon from "../../../assets/images/driver_icon.svg";
import { UnassignDriverIcon } from "../../common/CustomIcon";
import TenderEmailModal from "../../components/orders/tenders/TenderEmailModal";
import LhTrackingCard from "./LhTrackingNew/LhTrackingCard";

const { confirm } = Modal;

const LH_TRACKING_LABELS = ["LH", "NLH", "PLH", "LHD", "PLHD"];

const ViewOrderScreen = (props) => {
  const { form , order_id, orderResponse, currentPreplan, setOutofPreplan, setIsModified, 
    currentRoute, setEstimateRefreshKey = () => {}, updateItemDetails = () => {}, screenFrom= "orders",setActiveKey,
    refreshLhTracking: refreshLhTrackingProp,
    onLhTrackingRefreshed: onLhTrackingRefreshedProp,
    onLinehaulTrackingRefresh: onLinehaulTrackingRefreshProp,
  } = props;
  const { getFieldDecorator, setFieldsValue, getFieldValue} = form;

  const warehouseFilter = useContext(WarehouseContext);
  const { currentOrg, currentRole, orgRules } = useContext(UserContext);
  const { orderConfig } = useContext(OrderConfigContext);
  const isShipper = currentRole === "shipper";
  const { accountsExceeded, orgSettings } = useContext(OrgContext);
  const creditsExceededAccnts = accountsExceeded.map(account => account.account_code);



  const [orderDetails, setOrderDetails] = useState({
    account_id: _.get(orderResponse, "customer_order_details.account_id", ''),
    warehouse_id: _.get(orderResponse, "customer_order_details.warehouse_id", '')
  })
  const [locations, setLocations] = useState([])
  const [currentOrder, setCurrentOrder] = useState([])
  const [orderItems, setOrderItems] = useState([])
  const [vehicleTypes, setVehicleTypes] = useState([])
  const [referencesData, setReferencesData] = useState([])
  const [config, setConfig] = useState({}) 
  const [configLoading, setConfigLoading] = useState(false);
  const [dtiversData, setDtiversData] = useState([])
  const [selectedWarehouse, setSelectedWarehouse] = useState(null)
  const [currentAccount, setCurrentAccount] = useState(null)
  const [errors, setErrors] = useState([])
  const [orderTypeConfig, setOrderTypeConfig] = useState({})
  const [targetWarehouse, setTargetWarehouse] = useState(null)
  // P6a DB-driven order types: resolve the order-type config (legs + display)
  // from the move-type catalog when the org flag is on, mirroring
  // CreateOrderScreen. Off => byte-identical legacy enhancedOrderTypes path.
  // null index = flag off / fetch pending => legacy resolution.
  // Merged onto service_level_flow_enabled (2026-07-13) — same value as `modeA` below.
  const dbOrderTypesEnabled = orgSettings?.service_level_flow_enabled === "true";
  const [dbOrderTypeIndex, setDbOrderTypeIndex] = useState(null)
  // Mode A (service_level_flow_enabled): read-only Service Level block on the
  // details view — the order's SL name + move-type badge, mirroring create/edit.
  const modeA = orgSettings?.service_level_flow_enabled === "true";
  const [serviceLevelIndex, setServiceLevelIndex] = useState({})
  const [applicableServiceLevels, setApplicableServiceLevels] = useState([])
  const [loadingServiceLevels, setLoadingServiceLevels] = useState(false)
  const isCreditLimitExceed = currentOrder?.account?.account_code ? (creditsExceededAccnts.includes(currentOrder?.account.accountCode) ? true : false) : false;
  const isTender = orgSettings?.is_tender;
  
  const [accessorialDefs, setAccessorialDefs] = useState({ 
    orgComponents: [],
    displayComponents: [],
    noParamComponents: [],
    accountAccData: []
  })


  const detailsRef = useRef(null);
  const itemsRef = useRef(null);
  const isFirstLoad = useRef(true);
  const originalAccessorialsRef = useRef({});
  const labelInfoRef = useRef(null);
  const managerMailsRef = useRef(null);
  const subOrdersRef = useRef(null);
  const templateRef = useRef(null)
  const locationsRef = useRef([]);  
  const accessorialRef = useRef([]);
  const showAgentDetails = currentOrder?.has_tender_order || false;



  const handleValidate = (e) => {
    e.preventDefault();
    const locationData = locationsRef.current.map(ref => ref.current && ref.current()) || [];
    const errors = areAppointmentsInOrder(locationData)
    const onHandErrors = validateLtlOnHandTimes(locationData, isLtlOrganization(currentOrg), orderTypeConfig)
    const combinedErrors = [...(errors || []), ...(onHandErrors || [])]
    if(combinedErrors?.length > 0){
      setErrors(combinedErrors)
      combinedErrors.forEach((err) => renderNotification(err, "error"));
      return;
    } else {
      setErrors([])
    }
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        if(!combinedErrors?.lengh > 0){
          handleSave();
        }
      } else{
        renderNotification(`Please fill all required fields`, 'error')
      }
    });
  }



  const navigateToErrors = () => {
    const errBlock = document.querySelector(`.order_errors`);
    if (!isEmpty(errBlock)) {
      // scrollIntoViewIfNeeded
      errBlock.scrollIntoView({
        block: "start",
        behavior: "smooth",
      });
    }
  }

  const [order, setOrder] = useState({});
  const [warehouses, setWarehouses] = useState([])
  const [accounts, setAccounts] = useState([])
  const [levelOfServices, setLevelOfServices] = useState([])
  // Full org Standard rate-sheet LOS list — unioned into the inline edit's leg
  // dropdown so every Standard tariff is selectable (not only SL-mapped ones).
  const [standardLosList, setStandardLosList] = useState([])
  const [linehaulLevelOfServices, setLinehaulLevelOfServices] = useState([])
  const [standardLinehaulLosList, setStandardLinehaulLosList] = useState([])
  const [accountBillingConfig, setAccountBillingConfig] = useState({})
  const linehaulLosOptions = useMemo(
    () => (modeA
      ? withAllStandardLos(linehaulLevelOfServices, standardLinehaulLosList)
      : linehaulLevelOfServices),
    [modeA, linehaulLevelOfServices, standardLinehaulLosList]
  )
  const orderServiceLevelLegLos = useMemo(
    () => resolveOrderServiceLevelLegLos(
      applicableServiceLevels,
      currentOrder?.customer_order_details?.service_level_id
    ),
    [currentOrder?.customer_order_details?.service_level_id, applicableServiceLevels]
  )
  const linehaulTariffEditLocked = modeA
    && !checkServiceExistance("OLOS")
    && isLinehaulTariffLockedByServiceLevel(orderServiceLevelLegLos, linehaulLosOptions)
  const [isWhLoading, setWhLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [revokeEmailStage, setRevokeEmailStage] = useState(null);
  const [isNew, setIsNew] = useState(true);

  useEffect(() => {
    getWarehouses()
    getVehicleTypes()
    getOrderTypeConfig()
    getOrgcomponents()
    getDrivers()
  }, [])

  useEffect(() => {
    if (warehouses.length > 0 && isEmpty(orderDetails.warehouse_id)) {
      setDeafultWarehouse()
    }
    if(!selectedWarehouse && orderResponse?.customer_order_details?.warehouse_id){
      setSelectedWarehouse(_.find(warehouses, { id: orderResponse.customer_order_details.warehouse_id}) || null)
    }
  }, [warehouses])
  
  useEffect(() => { 
    setOrderDetails({
      ...orderDetails,
      account_id: _.get(orderResponse, "customer_order_details.account_id", ''),
      warehouse_id: _.get(orderResponse, "customer_order_details.warehouse_id", '')
    })
  }, [currentOrder])

  useEffect(() => {
    const typeObject = resolveTypeObject(orderResponse.order_label, orderResponse.extra_code);
    const existingLocatios = orderResponse.locations || []
    const newLocations = typeObject?.locations || []
    const updatedLocations = orderResponse?.type_of_order === "MS" ? existingLocatios :  newLocations.map(loc => {
      const  foundLocation = _.find(existingLocatios, { type_of_loc: loc.type_of_loc })
      return ({
        ...foundLocation,
        ...loc,
      })
    })
    setTargetWarehouse(_.get(orderResponse, "target_warehouse", ''))
    setCurrentOrder({...orderResponse, locations : [...updatedLocations]})

    if (!isFirstLoad.current) {
      const orderLocations = orderResponse?.locations || [];
      orderLocations.forEach(loc => {
        const locKey = loc.id || loc.loc_order_sequence;
        originalAccessorialsRef.current[locKey] = [];
        if (Array.isArray(loc.accessorials)) {
          loc.accessorials.forEach(orderAcc => {
            const directMatch = (accessorialDefs.accountAccData || []).find(
              newAcc => newAcc._id === orderAcc.account_accessorial_id || newAcc.id === orderAcc.account_accessorial_id
            );
            originalAccessorialsRef.current[locKey].push({
              ...orderAcc,
              organization_accessorial_id: directMatch ? directMatch.organization_accessorial_id : null
            });
          });
        }
      });
    }
  }, [orderResponse, dbOrderTypeIndex, accessorialDefs.accountAccData])

  const fetchAccountBillingConfig = async () => {
    if (modeA || !orderDetails.account_id || !currentOrg?.id) {
      setAccountBillingConfig({})
      return
    }
    const requestedAccountId = orderDetails.account_id
    try {
      const result = await fetchAccountBillingConfigs(currentOrg.id, requestedAccountId)
      if (requestedAccountId !== orderDetails.account_id) return
      if (result.success) {
        setAccountBillingConfig(parseBillingConfigurations(result.configurations || []))
      } else {
        setAccountBillingConfig({})
      }
    } catch (error) {
      console.error("Error fetching account billing config:", error)
      setAccountBillingConfig({})
    }
  }

  useEffect(() => {
    if (orderDetails.account_id) {
      setLinehaulLevelOfServices([])
      setStandardLinehaulLosList([])
      getLos()
      getLinehaulLos()
      getOrderReferences()
      fetchAccountConfig()
      fetchAccountBillingConfig()
      setCurrentAccount(_.find(accounts, {id: orderDetails.account_id}) || null)
    } else {
      setLevelOfServices([])
      setLinehaulLevelOfServices([])
      setStandardLinehaulLosList([])
      setAccountBillingConfig({})
      setCurrentAccount(null)
    }
  }, [orderDetails.account_id],accounts)

  useEffect(() => {
    if (modeA) setAccountBillingConfig({})
  }, [modeA])

  useEffect(() => {
    getLos()
    getLinehaulLos()
  }, [accounts])

  useEffect(() => {
    if (orderDetails.account_id && accessorialDefs.orgComponents?.length > 0) {
      getAccountComponentDefs()
    } 
  }, [accessorialDefs.orgComponents, orderDetails.account_id])

  useEffect(() => {
    if (orderDetails.warehouse_id) {
      setSelectedWarehouse(_.find(warehouses, { id: orderDetails.warehouse_id}) || null)
    } else {
      setSelectedWarehouse(null)
      setAccounts([])
    }
  }, [orderDetails.warehouse_id])

  useEffect(() => {
    if (orderDetails.suppres_schedule_dates) {
      handleSave()
    } 
  }, [orderDetails.suppres_schedule_dates])

  useEffect(() => {
    if (orderDetails.warehouse_id && isNew) {
     getAccounts()
    }
  }, [warehouseFilter.accounts, orderDetails.warehouse_id])

  // useEffect(() => {
  //   if (isNew && _.isEmpty(orderDetails.account_id) && accounts.length > 0) {
  //    updateOrderDetails
  //   }
  // }, [accounts])

  // Update locationsRef when locations change
  useEffect(() => {
    locationsRef.current = locations.map(() => React.createRef());
    accessorialRef.current = locations.map(() => React.createRef());
  }, [locations]);

  useEffect(() => {
    getOrderTypeConfig()
  }, [currentOrder?.customer_order_details?.order_label, dbOrderTypeIndex])

  // P6a: fetch the move-type catalog once when the DB-order-types flag is on
  // (auth-only). Populates dbOrderTypeIndex, which the two resolution effects
  // depend on so they re-resolve DB-first once it arrives. Mode A additionally
  // builds the SL->badge index for the read-only Service Level block. No-op
  // when both flags are off.
  useEffect(() => {
    if (!dbOrderTypesEnabled && !modeA) return
    let cancelled = false
    fetchSlCatalog({ orgId: currentOrg?.id }).then((catRes) => {
      if (cancelled) return
      if (catRes?.success) {
        if (dbOrderTypesEnabled) setDbOrderTypeIndex(buildOrderTypeConfigIndex(catRes.data))
        if (modeA) setServiceLevelIndex(buildServiceLevelIndex(catRes.data))
      }
    })
    return () => { cancelled = true }
  }, [modeA, currentOrg?.id])

  // Load the org Standard rate sheet's full LOS list, so the inline leg-LOS
  // edit can offer every Standard tariff (grouped) — mirrors CreateOrderScreen.
  useEffect(() => {
    if (!currentOrg?.id) return
    let cancelled = false
    Promise.all([fetchRateSheet(currentOrg.id), fetchSlLosOptions()]).then(([rsRes, losRes]) => {
      if (cancelled) return
      const standard = (rsRes?.rate_sheets || []).find((rs) => rs.is_default)
      if (!standard || !losRes?.success) return
      const list = []
      ;(losRes.data || []).forEach((o) => {
        if (String(o.rate_sheet_id) === String(standard.id)) {
          list.push({ id: String(o.id), code: o.code, name: o.name, rate_sheet_id: String(standard.id) })
        }
      })
      setStandardLosList(list)
    })
    return () => { cancelled = true }
  }, [currentOrg?.id])

  // Mode A: load the account's applicable service levels so the read-only block
  // can show the order's SL name (and its badge via serviceLevelIndex).
  const viewAccountId = currentOrder?.customer_order_details?.account_id;
  const viewServiceLevelId = currentOrder?.customer_order_details?.service_level_id;
  useEffect(() => {
    if (!modeA || !viewAccountId) return
    let cancelled = false
    setLoadingServiceLevels(true)
    // Pass the order's own SL id so a DEACTIVATED (soft-deleted) SL is still
    // returned (tagged is_active:false) and the read-only block can show it.
    // forAccount is .active-scoped otherwise and would drop the order's SL,
    // leaving the Service Level block blank. Mirrors CreateOrderScreen's edit fetch.
    fetchForAccount(viewAccountId, viewServiceLevelId).then((res) => {
      if (cancelled) return
      setApplicableServiceLevels(res?.success ? (res.data || []) : [])
      setLoadingServiceLevels(false)
    })
    return () => { cancelled = true }
  }, [modeA, viewAccountId, viewServiceLevelId])

  const [refreshLhTrackingLocal, setRefreshLhTrackingLocal] = useState(false);
  const refreshLhTracking = refreshLhTrackingProp ?? refreshLhTrackingLocal;

  const refreshDetails = () => {
      props.doRefreshDetails();
      setIsModified(true);
  }

  const refreshLinehaulTracking = () => {
    if (onLinehaulTrackingRefreshProp) {
      onLinehaulTrackingRefreshProp();
      return;
    }
    const label = currentOrder?.customer_order_details?.order_label
      || currentOrder?.order_label
      || orderTypeConfig?.code;
    if (!LH_TRACKING_LABELS.includes(label)) return;
    setRefreshLhTrackingLocal(true);
  }

  const handleLhTrackingRefreshed = () => {
    if (onLhTrackingRefreshedProp) {
      onLhTrackingRefreshedProp();
      return;
    }
    setRefreshLhTrackingLocal(false);
  }

  const getAccounts = () => {
    const accountsData = warehouseFilter.findMatchingAccounts(orderDetails.warehouse_id);
    
    const findFirstNonExceededAccount = (accounts) => {
      if (!accounts || accounts.length === 0) return null;
      return accounts.find(account => !creditsExceededAccnts.includes(account.code)) || null;
    };

    if(_.isEmpty(orderDetails.account_id) && isNew && accountsData.length > 0) {
      const firstNonExceededAccount = findFirstNonExceededAccount(accountsData);
      updateOrderDetails("account_id", firstNonExceededAccount ? firstNonExceededAccount.id : "")
    }
    setAccounts(accountsData)
  }
  const getOrgcomponents = async () => {
    try {
      const result = await getComponentDefs();
      if (result.success) {
          setAccessorialDefs({
            ...result.data,
            accountAccData: [],
          })
      }
    } catch (error) {
      console.error('Error using fetched data:', error);
    }
  }
  const getAccountComponentDefs = async () => {
    try {
      const result = await getAccountComponents (currentOrg.id, orderDetails.account_id, accessorialDefs.orgComponents, accessorialDefs.displayComponents);
      if (result) {
        const newAccountAccessorials = result.data ? [...result.data] : [];

        // On first run, cache the original accessorials with their organization accessorial link
        if (isFirstLoad.current) {
          const orderLocations = orderResponse?.locations || [];
          orderLocations.forEach(loc => {
            const locKey = loc.id || loc.loc_order_sequence;
            originalAccessorialsRef.current[locKey] = [];
            if (Array.isArray(loc.accessorials)) {
              loc.accessorials.forEach(orderAcc => {
                const directMatch = newAccountAccessorials.find(
                  newAcc => newAcc._id === orderAcc.account_accessorial_id || newAcc.id === orderAcc.account_accessorial_id
                );
                originalAccessorialsRef.current[locKey].push({
                  ...orderAcc,
                  organization_accessorial_id: directMatch ? directMatch.organization_accessorial_id : null
                });
              });
            }
          });
          isFirstLoad.current = false;
        }

        // Update currentOrder.locations
        setCurrentOrder(prevOrder => {
          if (prevOrder && Array.isArray(prevOrder.locations)) {
            const updatedLocations = prevOrder.locations.map(loc => {
              const locKey = loc.id || loc.loc_order_sequence;
              const originalAccs = originalAccessorialsRef.current[locKey] || [];
              const filteredAccs = originalAccs.reduce((acc, orderAcc) => {
                if (orderAcc.organization_accessorial_id) {
                  const orgMatch = newAccountAccessorials.find(
                    newAcc => newAcc.organization_accessorial_id === orderAcc.organization_accessorial_id
                  );
                  if (orgMatch) {
                    acc.push({
                      ...orderAcc,
                      account_accessorial_id: orgMatch._id || orgMatch.id
                    });
                  }
                } else {
                  const directMatch = newAccountAccessorials.find(
                    newAcc => newAcc._id === orderAcc.account_accessorial_id || newAcc.id === orderAcc.account_accessorial_id
                  );
                  if (directMatch) {
                    acc.push(orderAcc);
                  }
                }
                return acc;
              }, []);
              return {
                ...loc,
                accessorials: filteredAccs
              };
            });
            return {
              ...prevOrder,
              locations: updatedLocations
            };
          }
          return prevOrder;
        });

        // Also update locations state if it is used
        setLocations(prevLocations => {
          if (Array.isArray(prevLocations) && prevLocations.length > 0) {
            return prevLocations.map(loc => {
              const locKey = loc.id || loc.loc_order_sequence;
              const originalAccs = originalAccessorialsRef.current[locKey] || [];
              const filteredAccs = originalAccs.reduce((acc, orderAcc) => {
                if (orderAcc.organization_accessorial_id) {
                  const orgMatch = newAccountAccessorials.find(
                    newAcc => newAcc.organization_accessorial_id === orderAcc.organization_accessorial_id
                  );
                  if (orgMatch) {
                    acc.push({
                      ...orderAcc,
                      account_accessorial_id: orgMatch._id || orgMatch.id
                    });
                  }
                } else {
                  const directMatch = newAccountAccessorials.find(
                    newAcc => newAcc._id === orderAcc.account_accessorial_id || newAcc.id === orderAcc.account_accessorial_id
                  );
                  if (directMatch) {
                    acc.push(orderAcc);
                  }
                }
                return acc;
              }, []);
              return {
                ...loc,
                accessorials: filteredAccs
              };
            });
          }
          return prevLocations;
        });

        setAccessorialDefs(
          {
            ...accessorialDefs,
            accountAccData: newAccountAccessorials,
          })
      }
    } catch (error) {
      console.error('Error using fetched data:', error);
    }
  }
  const getOrderReferences = () => {
    fetchOrderReferences(currentOrg.id, orderDetails.account_id).then(
      (result) => {
        if (result.success) {
          setReferencesData(result.references || [])
        } else {
          renderAlertMessage(result.errors)
          setReferencesData([])
        }
      }
    );
  };
  

  const getLos = async () => {
    const accountIndex = _.findIndex(accounts, {
      id: orderDetails.account_id
    });

    if (accountIndex >= 0) {
      const account = accounts[accountIndex];
      let accountCode = account.code
      if (!isEmpty(account.primary_account_id)) {
        accountCode = getValueFromArrayOfObjects(
          accounts,
          "id",
          account.primary_account_id,
          "code"
        );
      }
      try {
        const result = await getLevelOfServices(accountCode, orderResponse?.type_of_order, 
          orderResponse?.order_label);
        if (result.success) {
          setLevelOfServices(sortServicesByNames(result.data, "name"))
        }
        // Use the fetched data here
      } catch (error) {
        console.error('Error using fetched data:', error);
      }
    }
  }

  const getLinehaulLos = async () => {
    const requestedAccountId = orderDetails.account_id;
    const accountIndex = _.findIndex(accounts, { id: requestedAccountId });
    if (accountIndex < 0) return;

    const account = accounts[accountIndex];
    let accountCode = account.code;
    if (!isEmpty(account.primary_account_id)) {
      accountCode = getValueFromArrayOfObjects(
        accounts,
        "id",
        account.primary_account_id,
        "code"
      );
    }

    try {
      const result = await getLinehaulLevelOfServices(
        accountCode,
        orderResponse?.order_label || orderDetails.label_code,
        currentOrg?.id,
        requestedAccountId
      );
      if (requestedAccountId !== orderDetails.account_id) return;
      if (result.success) {
        setLinehaulLevelOfServices(sortServicesByNames(result.data, "name"));
        setStandardLinehaulLosList(result.standardLinehaulLos || []);
      } else {
        setLinehaulLevelOfServices([]);
        setStandardLinehaulLosList([]);
      }
    } catch (error) {
      console.error("Error fetching linehaul tariffs:", error);
    }
  }

  const fetchAccountConfig = async() => {
    setConfigLoading(true);
    try {
        const result = await getAccountConfigs(orderDetails.account_id, orderResponse?.customer_order_details?.organization_id || currentOrg?.id);
        if (result.success) {
          setConfig(result.data)
        }
      } catch (error) {
        console.error('Error using fetched data:', error);
      } finally {
        setConfigLoading(false);
      }  
    }

  const getVehicleTypes = () => {
    VehicleTypeApi.fetch().then((result) => {
      if (result.success) {
        setVehicleTypes(result.vehicle_types || [])
      } else {
        renderAlertMessage(result.errors)
        setVehicleTypes(result.vehicle_types || [])
      }
    });
  };

  

  const setDeafultWarehouse = () => {
    if (isNew === true) {
      const { getWHDetails } = warehouseFilter;
      const currentWh = getWHDetails();
      updateOrderDetails("warehouse_id", (currentWh?.id || ''));
    }
  };
  const getWarehouses = () => {
    setWhLoading(true)
    fetchLocations(AppConfig.warehouseCode, 1, null).then((result) => {
      if (result.success) {
        setWarehouses(result.locations.locations || [])
      } else {
        renderAlertMessage(result.errors)
      }
    }).catch((err) => {
      renderAlertMessage(err)
    })
      .finally(() => {
        setWhLoading(false)
      });;
  };

  const getDrivers = async () => {
    const result = await fetchUsers("driver", 1, null);
    if (result.success) {
      if (currentOrg.code === 'SSF') {
        result.users.forEach((driver) => {
            driver.employee_code = `${driver.full_name} (${driver.employee_code})`
        });
      }
      setDtiversData(result.users || [])
    } else {
      setDtiversData([])
    }
  };

  const updateOrderDetails = (element, value) => {
    if(typeof(value) === 'object'){
      setOrderDetails({
        ...orderDetails,
        ...value
      });
    } else {
      setOrderDetails({
        ...orderDetails,
        [element]: value
      });
    }
    
  }

  const showActionsFunc = (isShipper, currentOrder) => {
    return !(
      isShipper || currentOrder?.customer_order_details?.is_locked === "true" || currentOrder?.is_deleted_order
    );
  };

  const handleItNumberChange = (itNumber) => {
    setCurrentOrder(prev => ({
      ...prev,
      label_info: {
        ...(prev.label_info || {}),
        it_number: itNumber,
      },
      customer_order_details: {
        ...(prev.customer_order_details || {}),
        it_number: itNumber,
      }
    }));
  };


  const handleUpdateWhStorage = () => {
    const locationData = locationsRef.current.map(ref => ref.current && ref.current()) || [];
    const isMultiDay = isMultiDayOrder(locationData)
    updateOrderDetails("wh_storage", isMultiDay)

  }

  const handleLocUpdate = (index, loc) => {
    const newLocations = _.cloneDeep(locations)
    newLocations[index] = loc;
    setLocations(newLocations)
  } 

  const handleDeleteDeliveryLocation = async (locationToDelete) => {
    const isTOrder = currentOrder?.type_of_order === "T";
    const isDeliveryPending = locationToDelete?.status === "PENDING";
    const isDeliveryLocation = locationToDelete?.type_of_loc === "DELIVERY";
    
    if (!isTOrder || !isDeliveryPending || !isDeliveryLocation) {
      renderNotification("Delivery location deletion is only allowed for T orders with PENDING delivery locations", "error");
      return;
    }

    try {
      setIsLoading(true);
      const result = await deleteDeliveryLocation(currentOrder.id);
      if (result?.success) {
        renderNotification(result?.message || "Delivery leg deleted successfully", "success");
        refreshDetails();
      } else {
        renderAlertMessage(result?.errors || ["Failed to delete delivery leg"]);
      }
    } catch (e) {
      console.error(e);
      renderNotification("Failed to delete delivery leg", "error");
    } finally {
      setIsLoading(false);
      }
  } 



  // P6a: DB-first resolution of the order-type config object, shared by both
  // enhancedOrderTypes lookup sites (getOrderTypeConfig + the location
  // re-templating effect). Returns null (=> legacy fallback) when the flag is
  // off, the catalog index hasn't loaded, an extra_code is present (legacy
  // variants like APAD), or the label is on the documented legacy-parity list
  // (CDK/WO). Mirrors CreateOrderScreen.resolveDbOrderTypeConfig.
  const resolveTypeObject = (orderLabel, extraCode) => {
    if (dbOrderTypesEnabled && dbOrderTypeIndex && !extraCode && !DB_ORDER_TYPE_LEGACY_FALLBACK.includes(orderLabel) && dbOrderTypeIndex[orderLabel]) {
      return _.cloneDeep(dbOrderTypeIndex[orderLabel]);
    }
    return _.find(orderConfig.enhancedOrderTypes, (o) => o.code === orderLabel || o.extraCode === orderLabel);
  };

  const getOrderTypeConfig = () => {
    if(currentOrder?.customer_order_details?.order_label){
      const typeObject = resolveTypeObject(currentOrder.customer_order_details.order_label, currentOrder?.customer_order_details?.extra_code);
      setOrderTypeConfig(typeObject)
      // const existingLocatios = _.cloneDeep(locationsRef.current.map(ref => ref.current && ref.current()) || [])
      // const newLocations = typeObject?.locations || []
      // const updatedLocations = newLocations.map(loc => {
      //   const  foundLocation = _.find(existingLocatios, { type_of_loc: loc.type_of_loc })
      //   return ({
      //     ...foundLocation,
      //     ...loc,
      //   })
      // })
      // setLocations(updatedLocations)
    }
    
  }

  const handleTypeChange = (orderType, code) => {
    setOrderDetails({
      ...orderDetails,
      type_of_order: orderType,
      label_code: code
    })
  }

  const renderDeatils = () => {
    return(<Row style={{ marginBottom: "20px" }}>
      <Col span={24}>
        <div>
          {/* <OrderdetailsComponent 
            accounts={accounts} 
            updateOrderDetails={updateOrderDetails}
            referencesData={referencesData}
            vehicleTypes={vehicleTypes}
            getDataRef={detailsRef}
            getFieldDecorator={getFieldDecorator}
            updatedAccountId={orderDetails.account_id}
            setFieldsValue={setFieldsValue}
            order_label_code={orderDetails.label_code}
            whStorage={orderDetails.wh_storage}

        /> */}
        <ManageDetails 
          warehouses={warehouses}
          accounts={accounts} 
          updateParentDetails={updateOrderDetails}
          referencesData={referencesData}
          vehicleTypes={vehicleTypes}
          details={currentOrder?.customer_order_details || {}}
          totalOrderDetails={currentOrder}
          updatedAccountId={orderDetails.account_id }
          levelOfServices={levelOfServices}
          currentOrder={currentOrder}
          currentOrg={currentOrg}
          refreshDetails={refreshDetails}
          history={props.history}
          showActions={showActionsFunc(isShipper, currentOrder)}
          isShipper={isShipper}
          currentPreplan={currentPreplan}
          setOutofPreplan={setOutofPreplan}
          setIsModified={setIsModified}
          currentRoute={currentRoute}
        />
        </div>
      </Col>
    </Row>)
  }
  
  const renderLocationDeatils = () => { 
    const haveMultipleLocations = currentOrder?.locations?.length > 1;
    const orderLabelCode = orderTypeConfig?.code || currentOrder?.customer_order_details?.order_label;
    const isLinehaulOrder = ["PLH","NLH", "LHD", "PLHD"].includes(orderLabelCode);
    // OLOS per-leg lock: the order's Service Level effective legs, so the inline
    // LOS edit is locked only on legs the SL supplies a default for (matches the
    // create/edit form). null when the order's SL isn't in the loaded set.
    const orderServiceLevelId = currentOrder?.customer_order_details?.service_level_id;
    const orderServiceLevel = (applicableServiceLevels || []).find((sl) => sl.service_level_id === orderServiceLevelId);
    const serviceLevelLegLos = orderServiceLevel ? buildLegLos(orderServiceLevel) : null;
    return(<Row className="marginTop20" gutter={[20, 20]} data-testid="location-view-section">
      {
        currentOrder?.locations.map((loc,index) => <Col xs={haveMultipleLocations ? 12 : 24} key={`location${loc.id}${index}`}>
          <AddressLocationsView
          location={{...loc}}
          currentOrder={currentOrder}
          serviceLevelLegLos={serviceLevelLegLos}
          orderTypeConfig={orderTypeConfig}
          selectedWarehouse={selectedWarehouse ? selectedWarehouse : ""}
          currentOrg={currentOrg}
          levelOfServices={levelOfServices}
          standardLosList={standardLosList}
          refreshDetails={refreshDetails}
          onLinehaulTrackingRefresh={refreshLinehaulTracking}
          updateLocationDetails={props.updateLocationDetails}
          updateDurationDetails={props.updateDurationDetails}
          updateReceivedDetails={props.updateReceivedDetails}
          updateDeliverByDetails={props.updateDeliverByDetails}
          updateAppointmentDetails={props.updateAppointmentDetails}
          updateActualDetails={props.updateActualDetails}
          updatePickupByDetails={props.updatePickupByDetails}
          updateOnHandDetails={props.updateOnHandDetails}
          accountId={orderDetails.account_id}
          config={config}
          showActions={showActionsFunc(isShipper, currentOrder)}
          isShipper={isShipper}
          currentPreplan={currentPreplan}
          setOutofPreplan={setOutofPreplan}
          setIsModified={setIsModified}
          orgSettings={orgSettings}
          currentRoute={currentRoute}
          warehouseFilter={warehouseFilter}
          locObj={loc}
          handleLocationUpdate={(loc) => handleLocUpdate(index, loc)}
          accessorialDefs={accessorialDefs}
          haveMultipleLocations={haveMultipleLocations}
          getFieldDecorator={getFieldDecorator}
          getAccountComponentDefs={getAccountComponentDefs}
          currentAccount={currentAccount || {}}
          handleUpdateWhStorage={handleUpdateWhStorage}
          targetWarehouse={targetWarehouse}
          setTargetWarehouse={setTargetWarehouse}
          dtiversData={dtiversData}
          disableEditLHOrder={isLinehaulOrder && loc.status !=="PENDING" ? true : false}
          onDeleteDeliveryLocation={handleDeleteDeliveryLocation}
          orgRules={orgRules}
          setIsLoading={setIsLoading}
          configLoading={configLoading}
          />
        </Col>)
      }
    </Row>)
  }
  const isTenderBoolean = isTender === "true";
  const renderDrivers = () => {
    
    if (currentOrder?.label_code === "CDK" || currentOrder?.label_code === "WO") {
      return null; 
    }
    if (currentOrder?.label_code === "CDKD" && _.find(currentOrder?.locations, {label_code: "CDK"})?.status !== "COMPLETED") {
      return null; 
    }

    const validLocations = currentOrder?.locations?.filter(loc => loc?.label_code !== "CDK") || [];
    const haveMultipleLocations = validLocations.length > 1;
    const isLinehaulOrder = ["PLH", "LHD", "PLHD","NLH"].includes(currentOrder?.customer_order_details?.order_label);
    const isImported = currentOrder?.customer_order_details?.is_imported === true || currentOrder?.customer_order_details?.is_imported === "true";
    const orderLabelCode = orderTypeConfig?.code || currentOrder?.customer_order_details?.order_label;

    return(<Row className="marginTop20" gutter={[20, 20]}>
      {
        currentOrder?.locations?.filter(loc => loc?.label_code !== "CDK").map(loc => {
          const baseAssignable = orgSettings?.order_assign_without_restriction === "true" ? loc?.is_assignable  : (["LHD", "PLHD"].includes(currentOrder?.order_label) && loc.type_of_loc === "DELIVERY" ? loc?.is_assignable : true);
          const isAssignable = baseAssignable && !isImported
          return (
            <Col data-testid={`${loc.label_name}-driver-view`} xs={haveMultipleLocations ? 12 : 24} key={`drivers${loc.id}`} >
              <AssignedDriverView 
                loc={loc} 
                isTender={isTenderBoolean}
                drivers={dtiversData} 
                warehouse_id={orderDetails.warehouse_id} currentOrder={currentOrder} 
                currentOrg={currentOrg}
                refreshDetails={refreshDetails}
                isCreditLimitExceed={isCreditLimitExceed}
                account={currentOrder.account || {}}
                showActions={showActionsFunc(isShipper, currentOrder)}
                isShipper={isShipper}
                setOutofPreplan={setOutofPreplan}
                setIsModified={setIsModified}
                isAssignable={isAssignable}
                isLinehaulOrder={isLinehaulOrder}
                organizationSettings={orgSettings}
              />
            </Col>
            );
        })}
    </Row>)
  }

  // const renderAgentDetails = () => {
  //   if (currentOrder?.label_code === "CDK") return null;

  //   const validLocations =
  //     currentOrder?.locations?.filter((loc) => loc?.label_code !== "CDK") || [];SHIPPED
  //   const haveMultipleLocations = validLocations.length > 1;

  //   return (
  //     <Row className="marginTop20" gutter={[20, 20]}>
  //       {validLocations.map((loc) => {
  //         const agent = loc?.tender_agent_details || null;

  //         return (
  //           <Col xs={haveMultipleLocations ? 12 : 24} key={`agent-${loc.id}`}>
  //             <SectionCard
  //               title={I18n.t("general.agent_details")}
  //               style={{ marginTop: 20 }}
  //               maximumHeight={"auto"}
  //               bodyStyle={{
  //                 display: "flex",
  //                 alignItems: "center",
  //                 justifyContent: "space-between",
  //                 padding: "16px",
  //               }}
  //             >
  //               {agent ? (
  //                 <div
  //                   style={{ display: "flex", alignItems: "center", flex: 1 }}
  //                 >
  //                   <div style={{ marginRight: "20%" }}>
  //                     <Icon type="user" style={{ fontSize: 30 }} />
  //                   </div>
  //                   <div>
  //                     <div className="fontSize18 textBold">
  //                       {agent.agent_name || "NA"}
  //                     </div>
  //                     <div className="fontSize16">
  //                       {agent.agent_code || "NA"}
  //                     </div>
  //                   </div>
  //                 </div>
  //               ) : (
  //                 <div
  //                   style={{
  //                     flex: 1,
  //                     display: "flex",
  //                     justifyContent: "center",
  //                     alignItems: "center",
  //                   }}
  //                 >
  //                   <h3 className="details_value_grey fontSize20">
  //                     {I18n.t("users.not_assigned")}
  //                   </h3>
  //                 </div>
  //               )}
  //             </SectionCard>
  //           </Col>
  //         );
  //       })}
  //     </Row>
  //   );
  // };
  
  // to render either driver details or agent details based on the has_tender_order flag

  const renderDriverOrTenderAgent = () => {
    if (currentOrder?.label_code === "CDK") return null;
  
    const validLocations =
      currentOrder?.locations?.filter((loc) => loc?.label_code !== "CDK") || [];
    const haveMultipleLocations = validLocations.length > 1;

    //
    const refType = currentOrder?.customer_order_details?.reference_1_type?.trim();
    const isTenderAgentSide =
      refType === "LOAD TENDER ORDER" &&
      refType !== "" &&
      currentOrder?.customer_order_details?.status === "PENDING";

          const handleRemoveAgent = (id, typeOfLoc, loc) => {
            // Agent load tender → Cancel Tender email modal; legacy is_tender → Yes/No confirm.
            const agent = loc?.tender_agent_details || {};
            // A real AgentTenderOrder doc stamps tender_number/batch_id; legacy is_tender agents
            // only get a fabricated leg_id server-side (customer_order_details_service:559), so
            // leg_id presence alone can't distinguish them — key off tender_number/batch_id.
            const hasRealTender = !!(agent.tender_number || agent.batch_id);
            if (orgSettings?.agent_load_tender === "true" && hasRealTender) {
              const agentId = agent.agent_id || loc?.fleet_agent_id;
              if (!agentId) {
                renderNotification("No agent found to revoke for this leg.", "error");
                return;
              }
              const legId =
                agent.leg_id ||
                (typeOfLoc === "DELIVERY" ? "del_1" : typeOfLoc === "PICKUP" ? "pu_1" : null);
              if (!legId) {
                // No resolvable leg → never send leg_ids: [] (server treats blank as revoke-all).
                renderNotification("No agent found to revoke for this leg.", "error");
                return;
              }
              const tnd = agent.tender_number || "";
              const tndLabel = tnd || "tendered orders";
              const emails = Array.isArray(agent.email)
                ? agent.email.filter(Boolean)
                : agent.email
                ? [agent.email]
                : [];
              setRevokeEmailStage({
                revokeOrders: [{ order_id: id, leg_ids: [legId] }],
                agentEmails: [
                  {
                    agent_id: agentId,
                    agent_name: agent.agent_name || agent.agent_code || "Agent",
                    tender_number: tnd,
                    email: emails,
                    subject: `Tender Cancelled – ${tndLabel}`,
                    description: `This is to inform you that the tender ${tndLabel} has been canceled. Please disregard the manifest and BOL previously sent.\n\nWe apologize for any inconvenience.`,
                    attachments: [],
                  },
                ],
              });
              return;
            }

            Modal.confirm({
              width: 500,
              content: "Are you sure you want to revoke this agent order?",
              cancelText: "No",
              okText: "Yes",
              loading: isLoading,
              onOk: () => {
                setIsLoading(true);
                let delete_tender_order = false;
                let delete_order = false;
                let delete_agent_order = true;
                deleteOrder(id, delete_tender_order, delete_order, delete_agent_order, typeOfLoc).then(() => {
                    renderNotification("Agent Order revoked successfully", "success");
                    refreshDetails();
                  })
                  .catch(() => {
                    renderNotification("Failed to remove agent", "error");
                  })
                  .finally(() => {
                    setIsLoading(false);
                  })
              },
            })
          }

    const isLocked = !showActionsFunc(isShipper, currentOrder);
    const isLinehaulOrder = ["PLH","NLH", "LHD", "PLHD"].includes(currentOrder?.customer_order_details?.order_label);
    const isImported = currentOrder?.customer_order_details?.is_imported === true || currentOrder?.customer_order_details?.is_imported === "true";
    const isImportedButNotCleared = isImported;
    const orderLabelCode = orderTypeConfig?.code || currentOrder?.customer_order_details?.order_label;
  
    return (
      <Row className="marginTop20" gutter={[20, 20]}>
        {validLocations.map((loc) => {
          const colSpan = haveMultipleLocations ? 12 : 24;
          const isLoadTenderOrder = loc?.has_tender == "true" || false; 
          const baseAssignable = orgSettings?.order_assign_without_restriction === "true" ? loc?.is_assignable : (["LHD", "PLHD"].includes(currentOrder?.order_label) && loc.type_of_loc === "DELIVERY" ? loc?.is_assignable : true);
          const isAssignable = baseAssignable && !isImportedButNotCleared;

          if (isLoadTenderOrder) {
            const agent = loc?.tender_agent_details || null;
  
            return (
             <Col xs={colSpan} key={`agent-${loc.id}`}>
              <SectionCard
                title={I18n.t("general.agent_details")}
                style={{ marginTop: 20 }}
                maximumHeight={"auto"}
                bodyStyle={{
                  padding: "0px",
                }}
              >
                {agent ? (
                  <Row
                    type="flex"
                    align="middle"
                    justify="space-between"
                    style={{
                      border: "1px solid #eef2f5",
                      borderRadius: "8px",
                      padding: "16px",
                    }}
                  >
                    {/* Avatar */}
                    <Col span={3}>
                      <img
                        src={agent?.image?.url || DriverIcon}
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                          objectFit: "cover",
                        }}
                      />
                    </Col>

                    {/* Details */}
                    <Col span={11}>
                      <Row style={{fontSize:"16px", fontWeight: 700, color: "#111314"}}>
                        {agent?.agent_name || "NA"}
                      </Row>

                      <Row type="flex" gutter={16}>
                        <Col style={{fontSize:"14px", fontWeight:400, color: "#111314"}}>
                          {agent?.agent_code || "NA"}
                        </Col>

                        <Col className="driver-num">
                          {agent?.mobile_number || ""}
                        </Col>
                      </Row>
                    </Col>

                    {/* Remove Button */}
                    {!isLocked && !["COMPLETED", "CLOSED", "ARCHIVED"].includes(currentOrder.status) && (loc?.status !== "COMPLETED") && (
                      <Col span={3}>
                      <Tooltip title="Revoke Agent Order" placement="top">
                          <UnassignDriverIcon
                            color="#576EC1"
                            className="assign-driver-btn"
                            onClick={() => handleRemoveAgent(orderResponse?.id, loc?.type_of_loc, loc)}
                          />
                      </Tooltip>
                        </Col>
                    )}
                  </Row>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "60px",
                    }}
                  >
                    <h3 className="details_value_grey fontSize20">
                      {I18n.t("users.not_assigned")}
                    </h3>
                  </div>
                )}

              </SectionCard>
            </Col>
            );
          } else {
            return (
              <Col xs={colSpan} key={`drivers-${loc.id}`}>
                <AssignedDriverView
                  loc={loc}
                  isTender={isTenderBoolean}
                  drivers={dtiversData}
                  warehouse_id={orderDetails.warehouse_id}
                  currentOrder={currentOrder}
                  currentOrg={currentOrg}
                  refreshDetails={refreshDetails}
                  isCreditLimitExceed={isCreditLimitExceed}
                  account={currentOrder.account || {}}
                  showActions={showActionsFunc(isShipper, currentOrder)}
                  isShipper={isShipper}
                  setOutofPreplan={setOutofPreplan}
                  setIsModified={setIsModified}
                  isTenderAgentSide={isTenderAgentSide}
                  isLinehaulOrder={isLinehaulOrder}
                  isAssignable={isAssignable}
                  organizationSettings={orgSettings}
                />
              </Col>
            );
          }
        })}
      </Row>
    );
  };  
  //
  

  const renderDocuments = () => {
    const haveMultipleLocations = currentOrder?.locations?.length > 1;
    return (
      <Row className="marginTop20" gutter={[20, 20]}>
        {
          currentOrder?.locations.map(loc => {  
            return (
              <Col xs={haveMultipleLocations ? 12 : 24} key={`documents${loc.id}`}>
                <Documents
                  getFieldDecorator={getFieldDecorator}
                  currentOrg={currentOrg}
                  accountId={orderDetails.account_id}
                  currentOrder={currentOrder}
                  typeOfOrder = {currentOrder.type_of_order}
                  documents={loc?.documents?.filter((doc) => doc?.picture_url !== null) || []}
                  locObj={loc}
                  config={config}
                  refreshDetails={refreshDetails}
                  showActions={!isShipper}
                  isShipper={isShipper}
                  setOutofPreplan={setOutofPreplan}
                  setIsModified={setIsModified}
                  actionType="view"
                  orderTypeConfig={orderTypeConfig}
                />
              </Col>
            );
          })
        }
      </Row>
    );
  }
  
  const renderLocationAccessorials = () => {
    const haveMultipleLocations = currentOrder?.locations?.length > 1;
    return(
    <Row className="marginTop20" gutter={[20, 20]} style={{marginTop:"10px"}}>
      {
        currentOrder?.locations.map(loc => {
          // const accessorials = loc.accessorials || [];
          // const authorizeDetails = {}
          // const allowedIds = {};
          // accessorialDefs?.accountAccData.forEach(
          //   (accessorial) => {
          //     const components = accessorial.components ? 
          //     accessorial.components.map(record => record.component_code)
          //     :
          //     [];
          //     allowedIds[accessorial.id] = [...components];
          // })
          // const orderAccessorials = setAccessorialResponse(
          //   accessorials,
          //   true,
          //   allowedIds,
          // )
          // orderAccessorials.forEach(rec => {
          //   if(!isEmpty(rec.authorized_by)){
          //     authorizeDetails[rec.accessorial_code] = {
          //       authorized_by: rec.authorized_by,
          //       authorization_code: rec.authorization_code,
          //       comments: rec.comments,
          //       is_modified: false,
          //     }
          //   }
          // })
        return( 
          <Col xs={haveMultipleLocations ? 12 : 24} key={`locAcc${loc.id}`} data-testid={`accessorials-${loc.label_name}-view`}>
                 <DispalyOrderAccessorial
                    // getDataRef={accessorialRef.current[index]}
                    accountComponentAccessorial={accessorialDefs?.accountAccData || []}
                    config={config}
                    displayComponents={accessorialDefs?.displayComponents || []}
                    title={getLabelDescriptionForLocation(loc.label_code, orderTypeConfig?.extraCode || orderTypeConfig?.code)}
                    //accRef={accessorialRef}
                    drivers={dtiversData}
                    updateOrderAccessorials={() => {}}
                    processingRecords={loc?.accessorials || []}
                   // prevAuthorizedInfo={authorizeDetails}
                    actionType={"view"}
                    currentOrg={currentOrg}
                    currentOrder={currentOrder}
                    accountId={currentOrder?.account?.id}
                    haveMultipleLocations={currentOrder?.locations?.length > 1 || false}
                    location={loc}
                    showActions={!(["PLH", "LHD"].includes(orderTypeConfig?.code) && ["ORN", "DST"].includes(loc?.label_code || "")) && showActionsFunc(isShipper, currentOrder)}
                    isShipper={isShipper}
                    setOutofPreplan={setOutofPreplan}
                    setIsModified={setIsModified}
                    setEstimateRefreshKey={setEstimateRefreshKey}
                    orderTypeConfig={orderTypeConfig}
                    refreshDetails={refreshDetails}
                  />
        </Col>)})
      }
    </Row>)
  }

  const renderConsigneeDetails = () => {
    const isLocked = !showActionsFunc(isShipper, currentOrder);
    return (
      <Row style={{ marginTop: 16 }}>
        <Col xs={24}>
          <ConsigneeDetails
            form={form}
            viewType="view"
            consigneeDetails={currentOrder?.consignee_details}
            currentOrder={currentOrder}
            currentOrg={currentOrg}
            refreshDetails={refreshDetails}
            updateLocationDetails={props.updateLocationDetails}
            updateDurationDetails={props.updateDurationDetails}
            updateReceivedDetails={props.updateReceivedDetails}
            updateDeliverByDetails={props.updateDeliverByDetails}
            updateAppointmentDetails={props.updateAppointmentDetails}
            updateActualDetails={props.updateActualDetails}
            updateConsigneeName={props.updateConsigneeName}
            updateConsigneePhone={props.updateConsigneePhone}
            updateConsigneeAddress={props.updateConsigneeAddress}
            orgSettings={orgSettings}
            locked={isLocked}
          />
        </Col>
      </Row>
    )
  }

  const renderItems = () => {

  const orderItemRemark = _.get(config, "item_remarks_label", "")
  const isRemarkPresent = _.get(config,"item_remarks","")

    return(<Row className="marginTop20">
      <Col xs={24}>
        {orgSettings?.items_measure_units_screen === 'true' ? (
          <ItemsMeasureUnits
            getDataRef={itemsRef}
            getFieldDecorator={getFieldDecorator}
            currentOrg={currentOrg}
            accountId={orderDetails.account_id}
            currentOrder={currentOrder}
            typeOfOrder = {currentOrder.type_of_order}
            actionType={"view"}
            refreshDetails={refreshDetails}
            showActions={showActionsFunc(isShipper, currentOrder)}
            isShipper={isShipper}
            form={form}
            setOutofPreplan={setOutofPreplan}
            setIsModified={setIsModified}
            locationsData = {currentOrder?.locations}
            itemRemarkLabel = {orderItemRemark}
            checkForRemark = {isRemarkPresent}
            orgSettings={orgSettings}
            updateItemDetails={updateItemDetails}
            screenFrom={screenFrom}
            config={config}

          />
        ) : (
          <ItemsMeasure
            getDataRef={itemsRef}
            getFieldDecorator={getFieldDecorator}
            currentOrg={currentOrg}
            accountId={orderDetails.account_id}
            currentOrder={currentOrder}
            typeOfOrder = {currentOrder.type_of_order}
            actionType={"view"}
            refreshDetails={refreshDetails}
            showActions={showActionsFunc(isShipper, currentOrder)}
            isShipper={isShipper}
            form={form}
            setOutofPreplan={setOutofPreplan}
            setIsModified={setIsModified}
            locationsData = {currentOrder?.locations}
            itemRemarkLabel = {orderItemRemark}
            checkForRemark = {isRemarkPresent}
            orgSettings={orgSettings}
            updateItemDetails={updateItemDetails}
            screenFrom={screenFrom}
            config={config}

          />
        )}
      </Col>
    </Row>)
  }
  const renderSubOrders = () => {
    return(<Row className="marginTop20" gutter={16}>
      <Col xs={24}>
          <SubOrders getDataRef={subOrdersRef} 
          getFieldDecorator={getFieldDecorator} 
          selectedWarehouse={selectedWarehouse} 
          accounts={accounts} 
          targetWarehouse={currentOrder.target_warehouse} 
          warehouseFilter={warehouseFilter}
          subOrders={currentOrder.sub_orders || []}
          showSave={!isShipper}
          currentOrder={currentOrder}
          refreshDetails={refreshDetails}
          currentOrg={currentOrg}
          showActions={showActionsFunc(isShipper, currentOrder)}
          isShipper={isShipper}
           setOutofPreplan={setOutofPreplan}
          setIsModified={setIsModified}
          screenMode="view"
          />
        </Col>
      </Row>
    );
  }
  const renderWHAccessorials = () => {
    return (
      <Col xs={12} data-testid="warehouse-accessorials-view">
        <WarehouseAccessorials
          currentOrg={currentOrg} 
          accountId={currentOrder?.account?.id || ''}
          currentOrder={currentOrder}
          actionType={"view"}
          savedRecords={currentOrder?.customer_order_details?.warehouse_accessorials || []}
          showActions={showActionsFunc(isShipper, currentOrder)}
          isShipper={isShipper}
          setOutofPreplan={setOutofPreplan}
          setIsModified={setIsModified}
        />
      </Col>)
  }

  const renderShipperdeatils = () => {
    return (
      <Col>
        <ShipperEmails 
         getDataRef={managerMailsRef} 
         getFieldDecorator={getFieldDecorator} 
         accountId={orderDetails.account_id}
         existingData={orderResponse?.account_manager_emails || []}
         currentOrder={currentOrder}
         isShipper={isShipper}
         />
      </Col>
    )
  }

  return (
    <Form className="createOrderScreen" onSubmit={handleValidate} data-testid="overview-screen">
       <Spin spinning={isWhLoading || isLoading}> 
        {
          !(currentOrder?.customer_order_details?.id) ? 
          <Skeleton />
          :
          <Row style={{ height: "100%", width: "100%", overflow: 'hidden' }} type="flex">
            <Col  style={{
              flex: 1,
              height: "calc(100vh - 125px)",
              // overflowY: "auto",
              width: "100%",
              padding: "16px",
              paddingTop: "16px",
              paddingBottom: "100px",
            }} 
            className="hide-scrollbar"
          >
           
  
           { errors?.length > 0 && <Row className="marginBottom10 order_errors">
              <Col xs={24}>
                <ErrorComponent errors={[...errors]}/>
              </Col>
           </Row>
           }

            {/* Mode A: read-only Service Level block (order's SL + move-type
                badge), mirroring the create/edit screens. Flag off => absent. */}
            {modeA && (
              <ServiceLevelHeader
                readOnly
                serviceLevels={applicableServiceLevels}
                serviceLevelIndex={serviceLevelIndex}
                selectedServiceLevelId={currentOrder?.customer_order_details?.service_level_id}
                loadingServiceLevels={loadingServiceLevels}
              />
            )}

            {/* First Nested Row */}
            {/* {renderDeatils()} */}
            {
              currentOrder.type_of_order === "MS" ? (
                <>
                <Row style={{ marginBottom: 16 }} className="multi_loc_block">
                <MultiStopLocationsView
                  locationsInfo={currentOrder.locations || []} 
                  currentOrder={currentOrder} 
                  orderTypeConfig={orderTypeConfig} 
                  selectedWarehouse={selectedWarehouse ? selectedWarehouse : ""}
                  currentOrg={currentOrg}
                  levelOfServices={levelOfServices}
                  refreshDetails={refreshDetails}
                  accountId={orderDetails.account_id}
                  config={config}
                  showActions={showActionsFunc(isShipper, currentOrder)}
                  isShipper={isShipper}
                  currentPreplan={currentPreplan}
                  setOutofPreplan={setOutofPreplan}
                  setIsModified={setIsModified}
                  orgSettings={orgSettings}
                  accessorialDefs={accessorialDefs}
                  orderDetails={orderDetails}
                  accountComponentAccessorial={accessorialDefs?.accountAccData || []}
                  displayComponents={accessorialDefs?.displayComponents || []}
                  title={""}
                  drivers={dtiversData}
                  updateOrderAccessorials={() => {}}
                  actionType={"view"}
                  haveMultipleLocations={currentOrder?.locations?.length > 1 || false}
                  getFieldDecorator={getFieldDecorator}
                  showShipperActions={!isShipper}
                  isCreditLimitExceed={isCreditLimitExceed}
                  account={currentOrder.account || {}}
                  updateAppointmentDetails={props.updateAppointmentDetails}
                  updateDeliverByDetails={props.updateDeliverByDetails}
                  updateLocationDetails={props.updateLocationDetails}
                  updateDurationDetails={props.updateDurationDetails}
                  updateReceivedDetails={props.updateReceivedDetails}
                  updateActualDetails={props.updateActualDetails}
                  updatePickupByDetails={props.updatePickupByDetails}
                  updateOnHandDetails={props.updateOnHandDetails}
                  orgRules={orgRules}
                />
                </Row>
                </>
              ) : (
                <div>
              {Object.keys(currentOrder?.linehaul_tracking_info || {}).length > 0 && (
                  <div style={{ marginBottom: "16px" }}>
                    <LhTrackingCard
                      data={currentOrder.linehaul_tracking_info}
                      orderLabel={currentOrder?.customer_order_details?.order_label}
                      serviceLevelLegLos={orderServiceLevelLegLos}
                      disableTariffEdit={linehaulTariffEditLocked}
                      onViewTracking={() => setActiveKey("tracking")}
                      currentPathId={
                        currentOrder?.linehaul_tracking_info?.lh_routing_path_id
                        || currentOrder?.linehaul_tracking_info?.path_id
                      }
                      originZipcode={
                        currentOrder?.locations?.find((loc) => loc.type_of_loc === "PICKUP")?.address?.zipcode
                        || currentOrder?.locations?.find((loc) => loc.type_of_loc === "PICKUP")?.customer_zipcode
                      }
                      destinationZipcode={
                        currentOrder?.locations?.find((loc) => loc.type_of_loc === "DELIVERY")?.address?.zipcode
                        || currentOrder?.locations?.find((loc) => loc.type_of_loc === "DELIVERY")?.customer_zipcode
                      }
                      pickupWarehouseId={currentOrder?.locations?.find((loc) => loc.type_of_loc === "PICKUP")?.warehouse_id}
                      deliveryWarehouseId={currentOrder?.locations?.find((loc) => loc.type_of_loc === "DELIVERY")?.warehouse_id}
                      customerOrderId={currentOrder.id}
                      linehaulLosOptions={linehaulLosOptions}
                      currentOrder={currentOrder}
                      accountBillingConfig={accountBillingConfig}
                      orgBillingRules={orgRules?.org_billing_rules || {}}
                      refreshLhTracking={refreshLhTracking}
                      onLhTrackingRefreshed={handleLhTrackingRefreshed}
                    />
                  </div>
                )}
                  {renderLocationDeatils()}
                </div>
              )
            }
            {currentOrder.type_of_order !== "MS" && renderLocationAccessorials()}
            {/* {currentOrder.type_of_order !== "MS" && !showAgentDetails ? renderDrivers() : renderAgentDetails()} */}
            {currentOrder.type_of_order !== "MS" && renderDriverOrTenderAgent()}
            <Row gutter={[20, 20]}>
              {renderWHAccessorials()}
              <Col xs={12} data-testid="order-label-info-view">
                <OrderLabelInfo 
                  getDataRef={labelInfoRef} 
                  getFieldDecorator={getFieldDecorator} 
                  currentOrg={currentOrg} 
                  labelInfo={currentOrder.label_info}
                  actionType="view"
                  currentOrder={currentOrder}
                  showActions={showActionsFunc(isShipper, currentOrder)}
                  isShipper={isShipper}
                  setOutofPreplan={setOutofPreplan}
                  setIsModified={setIsModified}
                  onItNumberChange={handleItNumberChange}
                />
              </Col>
            </Row>
            {currentOrder.type_of_order !== "MS" && renderDocuments()}
            {orgSettings?.require_consignee_details === "true" && renderConsigneeDetails()}
            {renderItems()}
            <div style={{marginTop:"20px"}}>
            {renderShipperdeatils()}
            </div>
            {currentOrder.type_of_order === 'LH' && currentOrder.order_label ==='LH' && renderSubOrders()}
    
          </Col>
          {/* <Col style={{ width: 256 , padding:"24px 16px", background: 'white'}}>
              <OrderViewSidebar currentOrder={currentOrder} currentOrg={currentOrg}/>
          </Col> */}
          <Col>
          </Col>
        </Row>

        }
     
      </Spin>
      {revokeEmailStage && (
        <TenderEmailModal
          key={`revoke-${(revokeEmailStage.agentEmails || []).map((a) => a.agent_id).join(",")}`}
          visible
          mode="revoke"
          orgId={currentOrg.id}
          agentEmails={revokeEmailStage.agentEmails}
          revokeOrders={revokeEmailStage.revokeOrders}
          onBack={() => setRevokeEmailStage(null)}
          onDone={() => {
            setRevokeEmailStage(null);
            refreshDetails();
          }}
        />
      )}
    </Form>
  );
};

export default withRouter(Form.create()(ViewOrderScreen));
